import { FunctionalComponent, h, JSX } from "preact";
// import { Link } from 'preact-router/match';
import style from "./style.scss";
import commonStyle from "../common/style.scss";

const Input = ({
  error,
  multiline,
  label,
  ...props
}: JSX.HTMLAttributes<HTMLTextAreaElement> &
  JSX.HTMLAttributes<HTMLInputElement> & {
    error?: string;
    multiline?: boolean;
    label?: string;
  }) => {
  return (
    <div
      className={[
        commonStyle.col,
        style.container,
        props.className,
        props.class,
      ].join(" ")}
    >
      {label && (
        <div
          className={[
            style.label,
            "text__size_label",
            "text__color_black",
          ].join(" ")}
        >
          {label}
        </div>
      )}
      {multiline ? (
        <textarea
          className={[
            style.input,
            "text__size_input",
            error ? style["input_error"] : "",
          ].join(" ")}
          {...props}
        />
      ) : (
        <input
          className={[
            style.input,
            "text__size_input",
            error ? style["input_error"] : "",
          ].join(" ")}
          {...props}
        />
      )}
      {error && (
        <div className={[style.error, "text__size_error"].join(" ")}>
          {error}
        </div>
      )}
    </div>
  );
};

export default Input;
